import { ApiError } from './client';

/** Message francais affichable pour n'importe quelle erreur remontee par l'API. */
export function messageErreur(error: unknown): string {
  if (error instanceof ApiError) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Une erreur inattendue est survenue.';
}
